import { AppManagementBridge } from '@/bridge/app-management.bridge';

export class AppManagementLocalService {
  /**
   * Reloads the app. Tries native reload when available; on failure or when not implemented,
   * falls back to web reload (window.location.reload()).
   */
  static async appReload(): Promise<void> {
    try {
      await AppManagementBridge.reload();
    } catch {
      AppManagementBridge.reloadWeb();
    }
  }
}
